import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Sobre from "@/pages/Sobre";
import Psicanalise from "@/pages/Psicanalise";
import Adolescentes from "@/pages/Adolescentes";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contato from "@/pages/Contato";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function PublicShell({ children }) {
  return (
    <>
      <Layout>{children}</Layout>
      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<PublicShell><Home /></PublicShell>} />
          <Route path="/sobre" element={<PublicShell><Sobre /></PublicShell>} />
          <Route path="/psicanalise" element={<PublicShell><Psicanalise /></PublicShell>} />
          <Route path="/adolescentes" element={<PublicShell><Adolescentes /></PublicShell>} />
          <Route path="/blog" element={<PublicShell><Blog /></PublicShell>} />
          <Route path="/blog/:slug" element={<PublicShell><BlogPost /></PublicShell>} />
          <Route path="/contato" element={<PublicShell><Contato /></PublicShell>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<PublicShell><Home /></PublicShell>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
